import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { isIE11, isEdge } from "../../../lib/client";
import { Corners } from "../../Button/Corners";
import { isButton } from "../../Button";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Group.styles";
export var Group = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Group, _React$Component);

  function Group() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Group.prototype;

  _proto.render = function render() {
    var _this = this;

    var style = {
      width: this.props.width
    };
    var first = null;
    var last = null;
    React.Children.forEach(this.props.children, function (child) {
      if (child && /*#__PURE__*/React.isValidElement(child)) {
        first = first || child;
        last = child;
      }
    });
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("span", {
      className: styles.root(),
      style: style
    }, React.Children.map(this.props.children, function (child) {
      var _cx, _cx2;

      if (!child || ! /*#__PURE__*/React.isValidElement(child)) {
        return null;
      }

      var isWidthInPercent = Boolean(child.props.width && child.props.width.toString().includes('%'));
      var itemCss = cx((_cx = {}, _cx[styles.item()] = true, _cx[styles.itemFirst()] = child === first, _cx));
      var corners = 0;

      if (child !== first) {
        corners |= Corners.TOP_LEFT | Corners.BOTTOM_LEFT;
      }

      if (child !== last) {
        corners |= Corners.TOP_RIGHT | Corners.BOTTOM_RIGHT;
      }

      if (isButton(child)) {
        child = /*#__PURE__*/React.cloneElement(child, {
          corners: corners
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: cx((_cx2 = {}, _cx2[styles.fixed()] = !isWidthInPercent, _cx2[styles.stretch()] = isWidthInPercent, _cx2[styles.stretchFallback()] = Boolean(isWidthInPercent && _this.props.width && (isIE11 || isEdge)), _cx2))
      }, /*#__PURE__*/React.createElement("div", {
        className: itemCss
      }, child));
    })));
  };

  return Group;
}(React.Component);
Group.__KONTUR_REACT_UI__ = 'Group';
Group.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};